import { z } from 'zod';

import { CustomsStateNotificationType, SortDirection, TransitGroup, TransitStatus } from '@e-origin/shared';

export const AdminTransitCriteriaSchema = z.object({
  filters: z.object({
    searchQuery: z.string().optional(),
    status: z.array(z.nativeEnum(TransitStatus)).optional(),
    filterByUsers: z.array(z.string()).optional(),
    group: z.nativeEnum(TransitGroup).optional(),
    filterByNotifications: z.array(z.nativeEnum(CustomsStateNotificationType)).optional(),
  }),
  pagination: z.object({ page: z.number(), size: z.number() }),
  sorting: z.object({ field: z.string(), direction: z.enum([SortDirection.ASC, SortDirection.DESC]) }),
});

export type AdminTransitCriteria = z.infer<typeof AdminTransitCriteriaSchema>;
